<template>
  <VueFinalModal
    :esc-to-close="true"
    class="flex justify-center items-center"
    content-class="relative flex flex-col w-[600px] mx-auto bg-white border rounded-lg"
  >
    <div v-if="!noSelection">
      <component :is="componentArray[componentName]" :ids="ids" :model="bulkActionModel" :filter="bulkActionFilter" :options="bulkActionOptions" @cancel="closeModal()" @close="closeModal()"></component>
    </div>
    <div v-if="noSelection">
      <div class="bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
        <div class="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
          <div class="ml-4 mt-4">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              No Selection
            </h3>
            <p class="mt-1 text-sm leading-5 text-gray-500">
              {{noSelectionMessage}}
            </p>
          </div>
          <div class="ml-4 mt-4 flex-shrink-0">
            <span class="inline-flex rounded-md shadow-sm">
              <button type="button" @click="closeModal()" class=" btn btn-primary">Close</button>
            </span>
          </div>
        </div>
      </div>
    </div>
    
  </VueFinalModal>
</template>

<script setup>
  import AssignOfficeForm from './bulk-action-forms/AssignOfficeForm.vue'
  import AssignPeopleGroupForm from './bulk-action-forms/AssignPeopleGroupForm.vue'
  import AssignProjectForm from './bulk-action-forms/AssignProjectForm.vue'
  import AssignReportingEntityForm from './bulk-action-forms/AssignReportingEntityForm.vue'
  import ChangeStateForm from './bulk-action-forms/ChangeStateForm.vue'
  import IssueChangeStateForm from './bulk-action-forms/IssueChangeStateForm.vue'
  import MergeForm from './bulk-action-forms/MergeForm.vue'
  import SuspendUserForm from './bulk-action-forms/SuspendUserForm.vue'
  import PersonRoleChangeStateForm from './bulk-action-forms/PersonRoleChangeStateForm.vue'
  import GenerateMapPdfForm from './bulk-action-forms/GenerateMapPdfForm.vue'
  import { onMounted, ref, computed } from 'vue'
  import { VueFinalModal } from 'vue-final-modal'

  const props = defineProps({
    params: Object,
  })

  const emit = defineEmits(['close'])

  const componentArray = {
    'assign-office-form': AssignOfficeForm,
    'assign-people-group-form': AssignPeopleGroupForm,
    'assign-project-form': AssignProjectForm,
    'assign-reporting-entity-form': AssignReportingEntityForm,
    'change-state-form': ChangeStateForm,
    'issue-change-state-form': IssueChangeStateForm,
    'merge-form': MergeForm,
    'suspend-user-form': SuspendUserForm,
    'person-role-change-state-form': PersonRoleChangeStateForm,
    'generate-map-pdf-form': GenerateMapPdfForm
  }

  let ids = ref(props.params.ids.map(id => parseInt(id)))
  let bulkAction = ref(props.params.bulkAction)
  let bulkActionModel = ref(props.params.bulkActionModel)
  let bulkActionFilter = ref(props.params.bulkActionFilter)
  let bulkActionOptions = ref(props.params.bulkActionOptions)
  let resultCb = props.params.resultCb

  onMounted(() => {
  })

  const componentName = computed(() => {
    return `${bulkAction.value}-form`
  })

  const isMerge = computed(() => {
    return bulkAction.value.startsWith('merge')
  })

  const minSelLen = computed(() => {
    return isMerge ? 2 : 1
  })

  const noSelection = computed(() => {
    return !ids.value || ids.value.length < minSelLen
  })

  const noSelectionMessage = computed(() => {
    return isMerge ? 'You must select at least 2 records to perform this action.' :
      'You have not selected any records to perform a bulk action on.'
  })

  function closeModal () {
    console.log("closeModal() closing")
    
    resultCb && resultCb()
    emit('close')
  }
</script>

<style>
  .vm--modal {
    overflow: initial !important;
  }
</style>
